<template>
  <div class="animated revealUp">
    <div class="section-title mb-3">
      {{ $t("add") }} {{ $t("purchase") }} {{ $t("order") }}
    </div>
    <section class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 2) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  v-on:click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <Tooltip :title="$t('purchaseOrder_selectCinema')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedVendor.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor", 1) }}</label
              >
              <b-dropdown
                :text="selectedVendor"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Vendor"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchVendor($event.target.value)"
                    v-on:keydown="onSearchVendor($event.target.value)"
                    v-on:search="onSearchVendor($event.target.value)"
                    v-model="searchVendor"
                  />
                </div>
                <b-dropdown-item
                  v-for="(vendor, vendorKey) in Vendors"
                  :key="vendorKey"
                  v-on:click="onSelectVendor(vendor)"
                  >{{ vendor.v_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <Tooltip :title="$t('purchaseOrder_selectVendor')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedVendor.length == 0"
              >Please Select Vendor.</span
            >
          </p>
        </div>

        <!-- <div class="col-md-12 mb-3 font-weight-bold">{{ $t("items") }}</div> -->

        <div class="section-wrapper col-12 px-3 mb-3">
        <div class="d-flex">
          <div
            class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center"
          >
            <div
              class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.itemsArray = !collapseObj.itemsArray"
            >
              <div class="">{{ $t("items") }}</div>
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="collapseObj.itemsArray"
              @click="collapseObj.itemsArray = !collapseObj.itemsArray"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="!collapseObj.itemsArray"
              @click="collapseObj.itemsArray = !collapseObj.itemsArray"
            ></span>
          </div>
        </div>
        <b-collapse
          v-model="collapseObj.itemsArray"
          class="pt-3 px-2 bor mb-4 back collapse show"
        >
          <section class="row">
            <div
              v-for="(item, vendorIndex) in RawMaterialsList"
              :key="`${vendorIndex}${vendorIndex}`"
              class="col-md-12"
            >
              <div class="row mb-3 align-items-center px-4" style="zoom:0.9;">
                <div class="col-md-11 inner-vendor-rate">
                  <div class="row pt-3">
                    <div
                      class="col-md-3"
                      :key="`__${vendorIndex}${vendorIndex}`"
                      :class="`__${vendorIndex}${vendorIndex}`"
                    >
                      <multiselect
                        :key="`___${vendorIndex}${vendorIndex}`"
                        :class="`___${vendorIndex}${vendorIndex}`"
                        :options="
                          item.showAll ? rawMaterialsNew : filterRW(rawMaterialsNew)
                        "
                        v-model="item.main_raw_material"
                        :searchable="true"
                        label="rm_name"
                        track-by="rm_id"
                        placeholder="Select Raw Material"
                        @select="onSelectNewRawMaterial($event, vendorIndex, 0)"
                        :allowEmpty="false"
                        :showLabels="false"
                      ></multiselect>
                      <p class="error_message">
                        <span v-if="submitted && item.rm_name.length == 0"
                          >Please Select Raw Material.</span
                        >
                      </p>
                    </div>

                    <div class="">
                      <div class="d-flex align-items-center pt-2">
                        <label class="mr-2">{{ "Show All" }}</label>
                        <b-form-checkbox
                          class="j-checkbox mb-1 pb-0"
                          v-model="item.showAll"
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                      <p class="error_message">
                        <span></span>
                      </p>
                    </div>

                    <div class="col-md-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="item.poi_qty"
                            type="number"
                            @input="calculateNetAmount(item)"
                            placeholder="Qty"
                          />
                          <label
                            :class="
                              item.poi_qty && item.poi_qty.length > 0 ? 'shift-up' : ''
                            "
                            >Qty</label
                          >
                        </div>
                      </div>
                      <p
                        v-if="submitted && item.poi_qty.length == 0"
                        class="error_message"
                      >
                        Please Select Quantity.
                      </p>
                    </div>
                  
                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <label :class="item.uom_unit.length > 0 ? 'shift-up' : ''"
                            >{{ $t("select") }} UOM</label
                          >
                          <b-dropdown
                            :text="item.uom_unit"
                            variant="dropdown-curve"
                            class="w-100"
                          >
                            <b-dropdown-item
                              v-for="(measurement, measurementkey) in item.uom_units"
                              :key="measurementkey"
                              v-on:click="onSelectUom(measurement, vendorIndex)"
                              >{{ measurement.uom_unit }}</b-dropdown-item
                            >
                          </b-dropdown>
                        </div>
                        <Tooltip :title="$t('purchaseOrder_selectUOM')" />
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && item.uom_id.length == 0"
                          >Please Select Unit of measurement.</span
                        >
                      </p>
                    </div>
                    <div class="col-md-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="item.poi_rate"
                            type="number"
                            @input="calculateNetAmount(item)"
                            placeholder="Qty"
                          />
                          <label
                            :class="
                              item.poi_rate && item.poi_rate.length > 0
                                ? 'shift-up'
                                : ''
                            "
                            >Rate</label
                          >
                        </div>
                      </div>
                      <p
                        v-if="submitted && item.poi_rate.length == 0"
                        class="error_message"
                      >
                        Please Select Rate.
                      </p>
                    </div>

                    <div class="col-md-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            :disabled="true"
                            v-model="item.poi_price"
                            type="text"
                            name="netamount"
                            id="netamount"
                            v-validate="'required|decimal'"
                            placeholder="."
                          />
                          <label>{{ $t("netAmount") }}</label>
                        </div>
                        <!-- <Tooltip :title="$t('purchaseOrder_NetAmount')" /> -->
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && errors.has('netamount')">{{
                          errors.first("netamount")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-md-2">
                      <div class="input-material">
                        <input
                          v-model="item.poi_tax_in_percentage"
                          type="number"
                          name="taxamount"
                          id="taxamount"
                          @input="calculateNetAmount(item)"
                          v-validate="'required|decimal'"
                          placeholder="."
                        />
                        <label>{{ $t("Tax(In %)") }}</label>
                      </div>
                      <label
                        style="font-size:10px;font-weight:bold"
                        v-if="item.poi_tax_amount"
                        >Tax Amount ({{ item.poi_tax_amount }})</label
                      >
                      <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" />-->
                      <p class="error_message">
                        <span v-if="submitted && errors.has('taxamount')">{{
                          errors.first("taxamount")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-md-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            :disabled="true"
                            v-model="item.poi_total_amount"
                            type="number"
                            name="totalrate"
                            id="totalrate"
                            v-validate="'required|decimal'"
                            placeholder="."
                          />
                          <label>{{ $t("total") }}</label>
                        </div>
                        <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && errors.has('totalrate')">{{
                          errors.first("totalrate")
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="d-flex justify-content-center mb-2">
                     <button
                      v-if="vendorIndex === RawMaterialsList.length - 1"
                      @click.prevent.stop="addVendor(vendorIndex)"
                      class="btn-transparent"
                    >
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                    </button>
                    <button
                      v-else
                      @click.prevent.stop="removeVendor(vendorIndex)"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </b-collapse>
      </div>

        <div
          v-if="false"
          v-for="(item, vendorIndex) in RawMaterialsList"
          class="col-md-12 mb-4"
          :key="`${vendorIndex}${vendorIndex}`"
        >
          <div
            class="row"
            style="border-bottom: 0.1px solid lightgrey"
            :key="`_${vendorIndex}${vendorIndex}`"
            :class="`_${vendorIndex}${vendorIndex}`"
          >
            <div
              class="col-md-3"
              :key="`__${vendorIndex}${vendorIndex}`"
              :class="`__${vendorIndex}${vendorIndex}`"
            >
              <multiselect
                :key="`___${vendorIndex}${vendorIndex}`"
                :class="`___${vendorIndex}${vendorIndex}`"
                :options="
                  item.showAll ? rawMaterialsNew : filterRW(rawMaterialsNew)
                "
                v-model="item.main_raw_material"
                :searchable="true"
                label="rm_name"
                track-by="rm_id"
                placeholder="Select Raw Material"
                @select="onSelectNewRawMaterial($event, vendorIndex, 0)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <p class="error_message">
                <span v-if="submitted && item.rm_name.length == 0"
                  >Please Select Raw Material.</span
                >
              </p>
            </div>
            <div class="">
              <div class="d-flex align-items-center mb-3 pt-2">
                <label class="mr-2">{{ "Show All" }}</label>
                <b-form-checkbox
                  class="j-checkbox mb-1 pb-0"
                  v-model="item.showAll"
                  name="check-button"
                ></b-form-checkbox>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.poi_qty"
                    type="number"
                    @input="calculateNetAmount(item)"
                    placeholder="Qty"
                  />
                  <label
                    :class="
                      item.poi_qty && item.poi_qty.length > 0 ? 'shift-up' : ''
                    "
                    >Qty</label
                  >
                </div>
              </div>
              <p
                v-if="submitted && item.poi_qty.length == 0"
                class="error_message"
              >
                Please Select Quantity.
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="item.uom_unit.length > 0 ? 'shift-up' : ''"
                    >{{ $t("select") }} UOM</label
                  >
                  <b-dropdown
                    :text="item.uom_unit"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(measurement, measurementkey) in item.uom_units"
                      :key="measurementkey"
                      v-on:click="onSelectUom(measurement, vendorIndex)"
                      >{{ measurement.uom_unit }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <Tooltip :title="$t('purchaseOrder_selectUOM')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && item.uom_id.length == 0"
                  >Please Select Unit of measurement.</span
                >
              </p>
            </div>
            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.poi_rate"
                    type="number"
                    @input="calculateNetAmount(item)"
                    placeholder="Qty"
                  />
                  <label
                    :class="
                      item.poi_rate && item.poi_rate.length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >Rate</label
                  >
                </div>
              </div>
              <p
                v-if="submitted && item.poi_rate.length == 0"
                class="error_message"
              >
                Please Select Rate.
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :disabled="true"
                    v-model="item.poi_price"
                    type="text"
                    name="netamount"
                    id="netamount"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("netAmount") }}</label>
                </div>
                <Tooltip :title="$t('purchaseOrder_NetAmount')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('netamount')">{{
                  errors.first("netamount")
                }}</span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="input-material">
                <input
                  v-model="item.poi_tax_in_percentage"
                  type="number"
                  name="taxamount"
                  id="taxamount"
                  @input="calculateNetAmount(item)"
                  v-validate="'required|decimal'"
                  placeholder="."
                />
                <label>{{ $t("Tax(In %)") }}</label>
              </div>
              <label
                style="font-size:10px;font-weight:bold"
                v-if="item.poi_tax_amount"
                >Tax Amount ({{ item.poi_tax_amount }})</label
              >
              <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" />-->
              <p class="error_message">
                <span v-if="submitted && errors.has('taxamount')">{{
                  errors.first("taxamount")
                }}</span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    :disabled="true"
                    v-model="item.poi_total_amount"
                    type="number"
                    name="totalrate"
                    id="totalrate"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("total") }}</label>
                </div>
                <Tooltip :title="$t('purchaseOrder_TotalAmount')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('totalrate')">{{
                  errors.first("totalrate")
                }}</span>
              </p>
            </div>

            <div
              class="col-lg-1 border-left d-flex align-items-center justify-content-center mb-2"
            >
              <button
                v-if="vendorIndex === RawMaterialsList.length - 1"
                @click.prevent.stop="addVendor(vendorIndex)"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="removeVendor(vendorIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="purchasOrderDetails.po_date"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="purchasOrderDetails.po_date"
                  name="purchasedate"
                  id="purchasedate"
                  v-validate="'required'"
                  typeable
                ></Datepicker>
                <label
                  :class="
                    purchasOrderDetails.po_date &&
                    typeof purchasOrderDetails.po_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $t("purchaseorderdate") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('purchaseOrder_PurchaseOrderDate')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('purchasedate')">{{
              errors.first("purchasedate")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="purchasOrderDetails.po_total_amount"
                name="totalamount"
                id="totalamount"
                v-validate="'required|decimal'"
              />
              <label>{{ $tc("totalamount", 2) }}</label>
            </div>
            <Tooltip :title="$t('purchaseOrder_TotalAmount')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('totalamount')">{{
              errors.first("totalamount")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="purchasOrderDetails.remarks"
              />
              <label>{{ $tc("remarks") }} (optional)</label>
            </div>
            <Tooltip :title="$t('purchaseOrder_TotalAmount')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("purchaseorderlock") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="purchasOrderDetails.po_lock"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <!--
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="purchasOrderDetails.po_is_active"
                type="checkbox"
                class="ios-checkbox"
                checked
                disabled
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        -->

        <div class="col-md-12 mb-4 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}</button
          >&nbsp;
          <router-link
            to="purchase-order"
            class="btn btn-default btn-outline-grey"
            >{{ $t("cancel") }}</router-link
          >
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      collapseObj: {
        itemsArray: true,
      },
      btenable: false,
      isRoleID: true,
      submitted: false,
      purchasOrderDetails: {
        cinema_id: "",
        v_id: "",
        po_date: new Date(),
        po_total_amount: "",
        po_lock: false,
        po_is_active: false,
        remarks: ""
      },
      searchRawMaterial: "",
      searchVendor: "",
      searchCinema: "",
      RawMaterialsList: [
        {
          main_raw_material: "",
          rm_name: "",
          rm_id: "",
          po_quantity: "",
          poi_qty: "",
          poi_rate: "",
          poi_tax_in_percentage: "",
          poi_tax_amount: "",
          uom_unit: "",
          uom_id: "",
          po_total_amount: "",
          SelectedRawMaterial: null,
          uom_units: [],
          firstTimeSet: 0,
          isNew: false,
          showAll: false
        }
      ],
      Cinemas: [],
      CinemasCopy: [],
      RawMaterials: [],
      RawMaterialsCopy: [],
      Vendors: [],
      VendorsCopy: [],
      measurements: [],
      selectedCinema: "",
      selectedVendor: "",
      selectedQuantity: "",
      selectedUom: "",
      listOfConversionRate: [],
      cinema_selected_new: [],
      rawMaterialsNew: [],
      selectedRawMaterialPrice: []
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
    this.getRawMaterialsListMain();
  },
  mounted() {
    this.getVendorsList();
    // this.getRawMaterials();
    // this.getunitsofmeasurements();
  },
  methods: {
    filterRW(rm) {
      let filtered = rm.filter(rm => {
        if (!this.purchasOrderDetails.v_id) return true;

        let v_ids = (rm.vendor_ids || "")
          .split(",")
          .map(x => String(x).trim())
          .map(x => parseInt(x));

        if (!rm.vendor_ids) return false;
        return v_ids.includes(parseInt(this.purchasOrderDetails.v_id));
      });

      // console.log({
      //   "rm.length": rm.length,
      //   "filtered.length": filtered.length
      // });
      // console.log({
      //   filtered
      // });

      return filtered;
    },
    onSelectNewRawMaterial(event, vendorIndex, rawKey) {
      console.log(event, vendorIndex, rawKey, "Rawww");
      let findIndexNew = this.RawMaterialsList.findIndex(x => {
        return x.rm_id == String(event.rm_id);
      });
      console.log("findIndexNew", findIndexNew);
      if (findIndexNew >= 0) {
        this.$toasted.show(` ${event.rm_name} already selected `);
        this.RawMaterialsList[vendorIndex]["main_raw_material"] = true;
        return false;
      }
      let checkIndex = this.RawMaterials.findIndex(x => {
        return x.rm_id == event.rm_id;
      });
      console.log(this.RawMaterials, checkIndex, "checkIndex");
      if (checkIndex >= 0) {
        this.onSelectRawMaterial(
          this.RawMaterials[checkIndex],
          vendorIndex,
          rawKey
        );
      } else {
        this.RawMaterialsList[vendorIndex]["rm_id"] = event.rm_id;
        this.RawMaterialsList[vendorIndex]["rm_name"] = event.rm_name;
        this.RawMaterialsList[vendorIndex]["rm_name"] = event.rm_name;
        this.RawMaterialsList[vendorIndex]["isNew"] = true;
        console.log("Raw Material Not Found In Vendor");
        this.getRelatedUom(vendorIndex, event.rm_id);
        console.log(this.RawMaterialsList);
      }
      this.RawMaterialsList[vendorIndex]["poi_tax_amount"] = "";
      this.RawMaterialsList[vendorIndex]["poi_tax_in_percentage"] = "";
      this.RawMaterialsList[vendorIndex]["poi_total_amount"] = "";
      this.RawMaterialsList[vendorIndex]["po_quantity"] = "";
      this.RawMaterialsList[vendorIndex]["poi_qty"] = "";
      this.RawMaterialsList[vendorIndex]["poi_rate"] = "";
      this.RawMaterialsList[vendorIndex]["poi_price"] = "";
      this.RawMaterialsList[vendorIndex]["uom_units"] = [];
      this.RawMaterialsList[vendorIndex]["uom_id"] = "";
      this.RawMaterialsList[vendorIndex]["uom_unit"] = "";
    },
    getRawMaterialsListMain: function() {
      this.rawMaterialsNew = [];
      let payload = {
        limit: 10000,
        currentPage: 1,
        searchKey: "rm_name",
        searchValue: "",
        columnName: "rm_name",
        orderBy: "asc",
        filter_is_active: "Y"
      };
      PosFnbService.GetRawMaterialsList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.rawMaterialsNew = data.Records;
            console.log(this.rawMaterialsNew);
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError); //message
    },
    onSearchRawMaterial: function(value) {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.RawMaterials = this.RawMaterialsCopy.filter(x => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.RawMaterials = this.RawMaterialsCopy;
      }
    },
    onSearchCinema: function(value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchVendor: function(value) {
      if (this.searchVendor && this.searchVendor.length > 0) {
        this.Vendors = this.VendorsCopy.filter(x => {
          if (
            x.v_name.toLowerCase().includes(this.searchVendor.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Vendors = this.VendorsCopy;
      }
    },
    clearSelectedDate: function() {
      this.purchasOrderDetails.po_date = "";
    },
    getCinemasList: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema({
                  cine_id: x.cine_id,
                  cine_name: x.cine_name
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList: function() {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.VendorsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterials: function() {
      let payload = {
        vendor_id: this.purchasOrderDetails.v_id
      };
      let loader = this.$loading.show();
      this.RawMaterialsList = [];
      this.addVendor();
      this.purchasOrderDetails.po_total_amount = 0;
      PosFnbService.GetVendorRateDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
            this.RawMaterialsCopy = data.Records;
            this.RawMaterials = this.RawMaterials.map(x => {
              x["singleItemPrice"] = parseFloat(x.vr_rate) / parseInt(x.vr_qty);
              x["singleTaxPrice"] =
                parseFloat(x.vr_tax_amount) / parseInt(x.vr_qty);
              x["singleTotalPrice"] =
                x["singleItemPrice"] + x["singleTaxPrice"];
              return x;
            });
            console.log("this.RawMaterials :", this.RawMaterials);
            // this.RawMaterials.map(x => {});
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError); //message
    },
    onSelectCinema: function(params) {
      this.cinema_selected_new = [params];
      console.log(this.cinema_selected_new, "this.cinema_selected_new");
      this.selectedCinema = params.cine_name;
      this.purchasOrderDetails.cinema_id = params.cine_id;
    },

    onSelectRawMaterial: function(params, index, rawkey) {
      console.log(params);

      let findIndexNew = this.RawMaterialsList.findIndex(x => {
        return x.rm_id == String(params.rm_id);
      });
      console.log("findIndexNew", findIndexNew);
      if (findIndexNew < 0) {
        this.RawMaterialsList[index].rm_name = params.rm_name;
        this.RawMaterialsList[index].rm_id = String(params.rm_id);
        this.RawMaterialsList[index].SelectedRawMaterial = params;
        this.RawMaterialsList[index].uom_unit = "";
        this.RawMaterialsList[index].uom_id = "";
        this.RawMaterialsList[index].poi_qty = "";
        this.RawMaterialsList[index].poi_rate = "";
        this.RawMaterialsList[index].poi_tax_in_percentage = "";

        this.getRelatedUom(index, params.rm_id);
        // this.CalculateSelectedRawMaterial(
        //   this.RawMaterialsList[index]["poi_qty"],
        //   index
        // );
      } else {
        this.$toasted.show(` ${params.rm_name} already selected `);
      }
    },
    getRelatedUom: function(index, rm_id) {
      let cinema_id = this.purchasOrderDetails.cinema_id
      PosFnbService.getUomFromRawMaterial({ rm_id, cinema_id: cinema_id })
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.RawMaterialsList[index].uom_units = data.Records;
            this.listOfConversionRate = data.UnitMeasurement;
            if (data.RawMaterialPrice.length > 0) {
              let checkVendorExist = data.RawMaterialPrice.filter(z => {
                return (
                  String(z.vendor_id) == String(this.purchasOrderDetails.v_id)
                );
              });
              this.selectedRawMaterialPrice = data.RawMaterialPrice;
              if (checkVendorExist.length > 0) {
                if (data.Records.length == 1) {
                  console.log(this.RawMaterialsList[index], "poi_rate");
                  this.RawMaterialsList[index].poi_rate = parseFloat(
                    checkVendorExist[0].singleRate
                  ).toFixed(2);
                  this.RawMaterialsList[index].uom_id =
                    checkVendorExist[0].uom_id;
                  this.RawMaterialsList[index].uom_unit =
                    this.RawMaterialsList[index].SelectedRawMaterial[
                      "uom_unit"
                    ] || null;
                  this.RawMaterialsList[index].poi_tax_amount =
                    parseFloat(checkVendorExist[0].singleTax).toFixed(2);
                  this.RawMaterialsList[
                    index
                  ].poi_tax_in_percentage = +parseFloat(
                    (checkVendorExist[0].singleTax * 100) /
                      checkVendorExist[0].singleRate
                  ).toFixed(2);
                }
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectVendor: function(params) {
      this.selectedVendor = params.v_name;
      this.purchasOrderDetails.v_id = params.v_id;
      this.getRawMaterials();

      // this.VendorList[index].v_name = params.v_name;
      // this.VendorList[index].v_id = params.v_id;
    },

    onSelectQuantity: function(params, index) {
      this.RawMaterialsList[index]["poi_qty"] = params.toString();
      this.CalculateSelectedRawMaterial(
        this.RawMaterialsList[index]["poi_qty"],
        index
      );
    },

    calculateNetAmount: function(item) {
      console.log(item);
      if (item.poi_rate && item.poi_qty) {
        item.poi_price = +parseFloat(item.poi_rate * item.poi_qty).toFixed(2);
      }

      if (item.poi_price && (item.poi_tax_in_percentage || item.poi_tax_in_percentage == 0)) {
        item.poi_tax_amount = +parseFloat(
          (item.poi_price * item.poi_tax_in_percentage) / 100
        ).toFixed(2);
      }

      if (item.poi_price && (item.poi_tax_amount || item.poi_tax_amount == 0)) {
        item.poi_total_amount = +parseFloat(
          item.poi_price + item.poi_tax_amount
        ).toFixed(2);
      }
      this.purchasOrderDetails.po_total_amount = 0;
      this.RawMaterialsList.map(x => {
        if (x.poi_total_amount) {
          this.purchasOrderDetails.po_total_amount += parseFloat(
            x.poi_total_amount
          );
        }
      });

      item.poi_price = parseFloat(item.poi_price || 0).toFixed(2)
      item.poi_tax_amount = parseFloat(item.poi_tax_amount || 0).toFixed(2)
      item.poi_total_amount = parseFloat(item.poi_total_amount || 0).toFixed(2)
      this.purchasOrderDetails.po_total_amount = parseFloat(this.purchasOrderDetails.po_total_amount || 0).toFixed(2)
    },
    CalculateSelectedRawMaterial: function(params, index) {
      if (this.RawMaterialsList[index]["isNew"]) {
        this.RawMaterialsList[index]["poi_total_amount"] = +parseFloat(
          parseFloat(this.RawMaterialsList[index]["poi_tax_amount"] || 0) +
            parseFloat(this.RawMaterialsList[index]["poi_price"] || 0)
        ).toFixed(2);
        this.purchasOrderDetails.po_total_amount = 0;
        this.RawMaterialsList.map(x => {
          this.purchasOrderDetails.po_total_amount += parseFloat(
            x.poi_total_amount
          );
        });

        console.log("Quantity Cannot Be Calculated", this.RawMaterialsList);
        return false;
      }
      if (params && String(params).length > 0) {
        this.RawMaterialsList[index]["vendor_rate_id"] =
          this.RawMaterialsList[index].SelectedRawMaterial["vr_id"] || null;

        if (this.RawMaterialsList[index].firstTimeSet == 0) {
          this.RawMaterialsList[index]["uom_unit"] =
            this.RawMaterialsList[index].SelectedRawMaterial["uom_unit"] ||
            null;

          this.RawMaterialsList[index]["uom_id"] =
            this.RawMaterialsList[index].SelectedRawMaterial["uom_id"] || null;
          this.RawMaterialsList[index].firstTimeSet = 1;
        }

        let fromUnit = this.listOfConversionRate.filter(x => {
          return (
            x.conversion_from ==
            this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
          );
        });

        let toUnit = this.listOfConversionRate.filter(x => {
          return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
        });

        if (fromUnit.length > 0 && toUnit.length > 0) {
          console.log(1);
          let from_kg =
            this.RawMaterialsList[index].SelectedRawMaterial["vr_qty"] *
            fromUnit[0].conversion_formula;
          let to_kg = parseInt(params) * toUnit[0].conversion_formula;
          let net_amount = parseFloat(
            (to_kg / from_kg) *
              this.RawMaterialsList[index].SelectedRawMaterial["vr_rate"]
          ).toFixed(2);
          let tax_amount = parseFloat(
            (to_kg / from_kg) *
              this.RawMaterialsList[index].SelectedRawMaterial["vr_tax_amount"]
          ).toFixed(2);
          let poi_total_amount = parseFloat(net_amount + tax_amount).toFixed(2);
          this.RawMaterialsList[index]["poi_price"] = net_amount;
          this.RawMaterialsList[index]["poi_tax_amount"] = tax_amount;
          this.RawMaterialsList[index]["poi_total_amount"] = poi_total_amount;
          this.RawMaterialsList[index]["poi_total_amount"] =
            parseInt(params) *
            this.RawMaterialsList[index].SelectedRawMaterial[
              "singleTotalPrice"
            ];
        } else {
          console.log(2);
          this.RawMaterialsList[index]["poi_price"] =
            parseInt(params) *
            this.RawMaterialsList[index].SelectedRawMaterial["singleItemPrice"];

          this.RawMaterialsList[index]["poi_tax_amount"] =
            parseInt(params) *
            this.RawMaterialsList[index].SelectedRawMaterial["singleTaxPrice"];

          this.RawMaterialsList[index]["poi_total_amount"] =
            parseInt(params) *
            this.RawMaterialsList[index].SelectedRawMaterial[
              "singleTotalPrice"
            ];
        }

        console.log(fromUnit, toUnit);

        this.RawMaterialsList[index]["poi_is_active"] = true;

        this.purchasOrderDetails.po_total_amount = 0;
        this.RawMaterialsList.map(x => {
          this.purchasOrderDetails.po_total_amount += parseFloat(
            x.poi_total_amount
          );
        });
      }
    },

    onSelectUom: function(params, index) {
      this.RawMaterialsList[index].uom_unit = params.uom_unit;
      this.RawMaterialsList[index].uom_id = params.uom_id;
      let checkVendorExist = this.selectedRawMaterialPrice.filter(z => {
        return String(z.vendor_id) == String(this.purchasOrderDetails.v_id);
      });
      let fromUnit = this.listOfConversionRate.filter(x => {
        return (
          x.conversion_from ==
          this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
        );
      });

      let toUnit = this.listOfConversionRate.filter(x => {
        return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
      });

      console.log(fromUnit, toUnit, checkVendorExist);

      if (fromUnit.length > 0 && toUnit.length > 0 && checkVendorExist.length) {
        console.log(1);
        let from_kg = 1 * fromUnit[0].conversion_formula;
        let to_kg = parseInt(1) * toUnit[0].conversion_formula;
        let net_amount = parseFloat(
          (to_kg / from_kg) * checkVendorExist[0]["singleRate"]
        ).toFixed(2);
        let tax_amount = parseFloat(
          (to_kg / from_kg) * checkVendorExist[0]["singleTax"]
        ).toFixed(2);
        console.log(tax_amount, net_amount);
        this.RawMaterialsList[index].poi_rate = +parseFloat(
          net_amount / 1
        ).toFixed(4);
        this.RawMaterialsList[index].poi_tax_amount = +parseFloat(
          tax_amount * (this.RawMaterialsList[index].poi_qty || 1)
        ).toFixed(2);
        this.RawMaterialsList[index].poi_price =
          net_amount * (this.RawMaterialsList[index].poi_qty || 1);
        this.RawMaterialsList[index].poi_tax_in_percentage = +parseFloat(
          (tax_amount * 100) /
            net_amount
        ).toFixed(4);
        this.RawMaterialsList[index]["poi_total_amount"] =
          this.RawMaterialsList[index].poi_price +
          this.RawMaterialsList[index].poi_tax_amount;
        console.log('this.RawMaterialsList[index]["poi_total_amount"]', this.RawMaterialsList[index]["poi_total_amount"]);
        console.log('this.RawMaterialsList[index]["poi_price"]', this.RawMaterialsList[index]["poi_price"]);
        console.log('this.RawMaterialsList[index]["poi_tax_amount"]', this.RawMaterialsList[index]["poi_tax_amount"]);
        console.log('this.RawMaterialsList[index]["poi_tax_in_percentage"]', this.RawMaterialsList[index]["poi_tax_in_percentage"]);
        if (this.RawMaterialsList[index].poi_qty) {
          this.purchasOrderDetails.po_total_amount = 0;
          this.RawMaterialsList.map(x => {
            if (x.poi_total_amount) {
              this.purchasOrderDetails.po_total_amount += parseFloat(
                x.poi_total_amount
              );
            }
          });
        }

        //   let poi_total_amount = parseFloat(net_amount + tax_amount).toFixed(2);
        //   this.RawMaterialsList[index]["poi_price"] = net_amount;
        //   this.RawMaterialsList[index]["poi_tax_amount"] = tax_amount;
        //   this.RawMaterialsList[index]["poi_total_amount"] = poi_total_amount;
        //   this.RawMaterialsList[index]["poi_total_amount"] =
        //     parseInt(params) *
        //     this.RawMaterialsList[index].SelectedRawMaterial["singleTotalPrice"];
        // }
        // this.CalculateSelectedRawMaterial(
        //   this.RawMaterialsList[index].poi_qty,
        //   index
        // );
      }
    },
    addVendor: function() {
      this.RawMaterialsList.push({
        rm_name: "",
        rm_id: "",
        poi_price: "",
        poi_tax_amount: "",
        poi_tax_in_percentage: "",
        poi_rate: "",
        poi_total_amount: "",
        po_quantity: "",
        poi_qty: "",
        uom_unit: "",
        uom_id: "",
        po_total_amount: "",
        SelectedRawMaterial: null,
        uom_units: [],
        firstTimeSet: 0,
        isNew: false,
        showAll: false
      });
    },
    removeVendor: function(index) {
      this.RawMaterialsList.splice(index, 1);
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let loader = this.$loading.show();

          this.btenable = true;
          let payload = {
            ...this.purchasOrderDetails,
            vendorList: this.RawMaterialsList
          };
          console.log("this.RawMaterialsList :", this.RawMaterialsList);
          PosFnbService.AddPurchaseOrder(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "purchase-order"
                });
              } else {
                this.$toasted.show(data.message);
              }
              loader.hide();
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style>
.sectionName {
  padding: 5px 0px;
  color: #4a87e1;
}
.sectionName .fs-17 {
  font-size: 17px !important;
}
.text-small-instruction {
  font-weight: 400;
}
.text-red {
  color: red;
}

.disable-field {
  cursor: not-allowed;
  opacity: 0.5;
}
.bor {
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}
.back {
  background-color: #f5f5f5;
}
.inner-vendor-rate {
  background-color: #fff;
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/addPurchaseOrder.vue